/**
 * Destination d'une notification : « où m'emmène ce clic ? »
 *
 * Le calcul vit dans le backend (services/notification_target_svc.py). Il y voit la base,
 * donc il sait résoudre ce que le navigateur ignore — l'UUID d'inventaire d'un poste
 * derrière un agent_id, la société d'un relevé bancaire manquant.
 *
 * Ce module suit, il ne devine pas. Un `switch` de 75 lignes vivait ici et se terminait par
 * un repli qui cherchait un nombre de 4 à 6 chiffres dans le TITRE de la notification :
 * « Briefing du 12/08/2026 » y attrapait 2026 et partait sur /tickets?search=2026. Le repli
 * ne comblait pas un vide, il fabriquait une fausse piste. Il a été retiré : sans
 * destination, la ligne est muette (ni chevron, ni navigation).
 */

/** Un lien de notification navigue DANS le portail. `//evil.tld` est absolu pour le
 *  navigateur bien qu'il commence par un slash — d'où le second test. */
function cheminInterne(valeur) {
  if (typeof valeur !== 'string') return null;
  const chemin = valeur.trim();
  if (!chemin.startsWith('/') || chemin.startsWith('//')) return null;
  return chemin;
}

/** Destination d'une notification, ou `null` si le backend n'en connaît pas. */
export function getNotificationLink(n) {
  if (!n) return null;
  // `target_url` racine = champ calculé par le backend. `data.target_url` reste lu pour
  // une réponse servie avant le déploiement (onglet resté ouvert, cache navigateur).
  return cheminInterne(n.target_url) || cheminInterne((n.data || {}).target_url);
}
